import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { MARKETPLACE_URL, Reveal } from "./shared";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer data-testid="footer" className="relative overflow-hidden bg-background py-24 md:py-32">
    <div className="absolute inset-0 grid-lines opacity-40" />
    <div className="relative z-10 mx-auto w-full max-w-screen-2xl px-6 md:px-12">
      <Reveal>
        <span className="label-mono">Ready to deploy?</span>
        <h2 className="mt-6 font-display text-4xl font-black uppercase leading-[0.92] tracking-tighter text-white sm:text-6xl md:text-7xl lg:text-8xl">
          Launch it in
          <br />
          <span className="text-primary">your own cloud.</span>
        </h2>

        <motion.a
          href={MARKETPLACE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-marketplace-button"
          whileHover={{ x: 6 }}
          className="group mt-10 inline-flex items-center gap-4 bg-primary px-10 py-5 font-mono text-sm uppercase tracking-widest text-white transition-colors duration-200 hover:bg-[#FF7733]"
        >
          Launch in AWS Marketplace
          <ArrowUpRight className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </motion.a>
      </Reveal>

      <div className="mt-24 flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
        <div className="flex items-center gap-2">
          <Logo className="h-7 w-7" withWordmark testId="footer-logo-mark" />
        </div>
        <div className="flex flex-wrap gap-8 font-mono text-xs uppercase tracking-widest text-neutral-500">
          <a href="#docs" className="transition-colors hover:text-white">Docs</a>
          <a href="#workflows" className="transition-colors hover:text-white">Workflows</a>
          <a href="#support" className="transition-colors hover:text-white">Support</a>
        </div>
        <span className="font-mono text-xs uppercase tracking-widest text-neutral-600">
          © {new Date().getFullYear()} Jamila Ticket System · Runs on EC2
        </span>
      </div>
    </div>
  </footer>
);
